import Auth from "@creditsafe/upp-authentication";

const ONE_MINUTE_IN_MS = 60 * 1000;

export const ACTIVITY_STORAGE_KEY = "activity";
export const DEFAULT_INACTIVITY_THRESHOLD_MS = 4 * 60 * ONE_MINUTE_IN_MS;

interface IInactivityLogoutWatcherOptions {
  activityStorageKey?: string;
  logoutAfterIdleMs?: number;
  onUserIdle?(): void;
}

const getLastUserActivityTime = (storageKey: string): number | null => {
  const storedValue = localStorage.getItem(storageKey);
  const lastActivityTimestamp = Number(storedValue);
  return storedValue && !Number.isNaN(lastActivityTimestamp)
    ? lastActivityTimestamp
    : null;
};

const signOutUser = (): void => {
  try {
    Auth.signOut();
  } catch {
    window.location.reload();
  }
};

export const startInactivityLogoutWatcher = (
  options: IInactivityLogoutWatcherOptions = {}
): (() => void) => {
  const {
    activityStorageKey = ACTIVITY_STORAGE_KEY,
    logoutAfterIdleMs = DEFAULT_INACTIVITY_THRESHOLD_MS,
    onUserIdle = signOutUser,
  } = options;

  let logoutTimerId: number;

  const scheduleLogoutCheck = (): void => {
    const lastUserActivityTime = getLastUserActivityTime(activityStorageKey);
    const idleTimeMs = lastUserActivityTime
      ? Date.now() - lastUserActivityTime
      : 0;

    if (idleTimeMs >= logoutAfterIdleMs) {
      onUserIdle();
    } else {
      const remainingIdleTimeMs = logoutAfterIdleMs - idleTimeMs;
      logoutTimerId = window.setTimeout(
        scheduleLogoutCheck,
        remainingIdleTimeMs
      );
    }
  };

  scheduleLogoutCheck();

  return (): void => window.clearTimeout(logoutTimerId);
};
